import React from 'react'
import { CloseOutlined, SolutionOutlined } from '@ant-design/icons'
import { Avatar } from 'antd'
import moment from 'moment'
import { getLicenseFHAIcon } from './LicenseSetup'

const LicenseList = (props) => {
  const isReadOnly = !props.removeLicense
  if (props.addedLicenses && props.addedLicenses.length > 0) {
    return (
      <div>
        {props.addedLicenses.length > 0 && props.showLicenseHeaderText ? <p>{props.addedLicenses.length === 1 ? 'My license:' : 'My licenses:'}</p> : null}
        {props.addedLicenses.map((license) => {
          return (
            <div key={license.id} className='license-card-added'>
              <div className="invitation-contents license-invitation-contents-container">
                <div className="license-invitation-details-container">
                  <Avatar size="large" icon={<SolutionOutlined />} />
                  <div className='invitation-details'>
                    <p className='invitee'>{license.first_name} {license.last_name}</p>
                    <small className='invitee-reason'>License #: {license.license_number}, State: {license.state} </small>
                    <small className='invitee-reason'>Type: {license.license_type}, Expiration: {moment(license.expiration_date).format('YYYY-MM-DD')}, FHA: {getLicenseFHAIcon(license.is_fha)} </small>
                  </div>
                </div>
                {!isReadOnly && (
                  <CloseOutlined
                    onClick={() => props.removeLicense(license)}
                    className='license-remove-added-license-icon' />
                )}
              </div>
            </div>
          )
        })}
      </div>
    )
  }

  return null
}

export default LicenseList
